import { __assign, __makeTemplateObject } from "tslib";
import kebabCase from 'lodash/kebabCase';
import get from 'lodash/get';
import styled from 'styled-components';
export var themeGet = function (lookup, fallback) { return function (_a) {
    var theme = (_a === void 0 ? {} : _a).theme;
    return get(theme, lookup, fallback);
}; };
export var getComponentVariant = function (theme, componentName, variant) {
    var config = themeGet("variants." + componentName + "." + variant)({
        theme: theme,
    });
    if (!config) {
        throw new Error("Molekule: \"" + variant + "\" variant not found in theme...");
    }
    return config;
};
export var getComponentSize = function (theme, componentName, size) {
    return themeGet("sizes." + componentName + "." + size, {})({ theme: theme });
};
export var getComponentStyle = function (componentName) { return themeGet("styles." + componentName, {}); };
export var getVariantStyles = function (componentName, variant) {
    return themeGet("variants." + componentName + "." + variant + ".style", {});
};
var getComponentClassName = function (_a, name) {
    var className = _a.className, classPrefix = _a.theme.classPrefix, variant = _a.variant;
    return ((className || '') + " " + classPrefix + "-" + name + " " + (variant ? classPrefix + "-" + name + "-" + variant : '')).trim();
};
export var createComponent = function (_a) {
    var name = _a.name, _b = _a.tag, tag = _b === void 0 ? 'div' : _b, as = _a.as, style = _a.style, _c = _a.props, getBaseProps = _c === void 0 ? function () { return ({}); } : _c;
    var component = styled((as || tag));
    return component.attrs(function (props) {
        var baseProps = getBaseProps(props);
        var finalProps = {
            ...baseProps,
            ...props,
            className: baseProps.className || props.className,
        };
        return {
            ...finalProps,
            className: getComponentClassName(finalProps, kebabCase(name)),
        };
    })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n"])), style, getComponentStyle(name), function (p) { return getVariantStyles(name, p.variant); }, function (_a) {
        var _b = _a.styles, styles = _b === void 0 ? {} : _b;
        return styles[name] || {};
    });
};
var focusableFilter = function (node) {
    return node.tabIndex >= 0 && !node.hasAttribute('disabled') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
};
var createTreeWalker = function (root, currentNode, filterFn) {
    if (filterFn === void 0) { filterFn = function () { return NodeFilter.FILTER_ACCEPT; }; }
    var treeWalker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode: filterFn,
    }, false);
    treeWalker.currentNode = currentNode;
    return treeWalker;
};
export var findPreviousFocusableElement = function (root, currentNode) {
    var treeWalker = createTreeWalker(root, currentNode, focusableFilter);
    if (!treeWalker.previousNode() || treeWalker.currentNode === root) {
        return treeWalker.lastChild();
    }
    return treeWalker.currentNode;
};
export var findNextFocusableElement = function (root, currentNode) {
    var treeWalker = createTreeWalker(root, currentNode, focusableFilter);
    if (!treeWalker.nextNode() || treeWalker.currentNode === root) {
        treeWalker.currentNode = root;
        return treeWalker.firstChild();
    }
    return treeWalker.currentNode;
};
export var getNextCursorPosition = function (cursorPos, oldValue, newValue) {
    var cursorDiff = newValue.length - oldValue.length;
    var nextPosition = cursorPos;
    if (cursorDiff > 1 || cursorDiff < -1) {
        nextPosition += cursorDiff < 0 ? cursorDiff + 1 : cursorDiff - 1;
    }
    return Math.max(nextPosition, 0);
};
export var getEmptySlidesCount = function (slidesLength, visibleSlidesCount) {
    if (visibleSlidesCount <= 0 || slidesLength <= 0) {
        return 0;
    }
    return slidesLength % visibleSlidesCount === 0 ? 0 : visibleSlidesCount - (slidesLength % visibleSlidesCount);
};
export var dynamicAttributes = function (attribute, value) {
    if (value) {
        var opts = {};
        opts[attribute] = value;
        return opts;
    }
    return false;
};
var templateObject_1;
//# sourceMappingURL=utils.js.map